import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import stl from "./ProfileLayout.module.css";
var ProfileLayOut = function ProfileLayOut(_ref) {
  var className = _ref.className,
    title = _ref.title,
    userInfo = _ref.userInfo,
    wideContainer = _ref.wideContainer,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames(stl.container, className)
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("span", {
    className: "container"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, stl.userInfo, userInfo), "container", !userInfo), stl.subContainer, true), stl.wideContainer, wideContainer))
  }, children)));
};
export default ProfileLayOut;